import { useState, useCallback } from 'react';
import { SociogramApi } from '@BUP/services/Axios';

export const useSendActivationSurvey = (surveySociogram) => {
  const surveyId = surveySociogram?.id;

  const [state, setState] = useState({
    loadingResponseSurvey: true,
    dataResponseSurvey: null,
    errorResponseSurvey: null,
  });
  const updateSurveySociogram = useCallback(
    async ({ data }) => {
      setState((prevState) => ({
        ...prevState,
        loadingResponseSurvey: true,
      }));
      try {
        const response = await SociogramApi.put(`/surveys/${surveyId}`, data);
        setState((prevState) => ({
          ...prevState,
          dataResponseSurvey: response.data,
          errorResponseSurvey: null,
        }));
        return response.data;
      } catch (error) {
        console.log(error);
        if (state.dataResponseSurvey !== null) {
          setState((prevState) => ({
            ...prevState,
            errorResponseSurvey: null,
          }));
        } else {
          setState((prevState) => ({
            ...prevState,
            errorResponseSurvey: error.message,
            dataResponseSurvey: null,
          }));
        }

        // setState((prevState) => ({
        //   ...prevState,
        //   errorResponseSurvey: error.message,
        // }));
      } finally {
        setState((prevState) => ({
          ...prevState,
          loadingResponseSurvey: false,
        }));
      }
    },
    [setState, surveyId]
  );
  return {
    loadingResponseSurvey: state.loadingResponseSurvey,
    dataResponseSurvey: state.dataResponseSurvey,
    errorResponseSurvey: state.errorResponseSurvey,
    updateSurveySociogram,
  };
};
